﻿import React from 'react';
import { SvgIcon } from '@material-ui/core';
import { withTheme, withStyles } from '@material-ui/core';

const styles = (theme) => {
  return {
    root: {
      width: 14,
      height: 14,
    },
  };
};

export default withTheme(
  withStyles(styles)((props) => {
    return (
      <SvgIcon width="8px" height="14px" viewBox={'0 0 8 14'} {...props}>
        <g id="Admin-V2-revision-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            id="New-App_manage_doc_notification"
            transform="translate(-1154.000000, -1233.000000)"
            fill={props.fill || '#00B7C1'}
            fillRule="nonzero"
          >
            <g id="download" transform="translate(1154.000000, 1233.000000)">
              <path
                d="M7.15558297,12.3335839 L0.644082682,12.3335839 C0.288168942,12.3342564 0,12.6229704 0,12.9788848 C0,13.3347992 0.288168942,13.6235131 0.644082682,13.6241856 L7.15558297,13.6241856 C7.51149671,13.6235131 7.79966565,13.3347992 7.79966565,12.9788848 C7.79966565,12.6229704 7.51149671,12.3342564 7.15558297,12.3335839 L7.15558297,12.3335839 Z"
                id="Path"
              ></path>
              <path
                d="M3.44398182,10.4975839 C3.69599175,10.7495862 4.10457247,10.7495862 4.35658239,10.4975839 L7.42018355,7.4330842 C7.58356469,7.2701361 7.64750479,7.03235009 7.58788094,6.80943648 C7.52825708,6.58652287 7.3541443,6.41241008 7.13123069,6.35278623 C6.90831708,6.29316238 6.67053107,6.35710248 6.50758297,6.52048362 L4.54558182,8.48315985 L4.54558182,0.64529975 C4.54558183,0.414756359 4.4225884,0.201725474 4.22293197,0.0864537748 C4.02327554,-0.0288179249 3.77728867,-0.0288179249 3.57763224,0.0864537748 C3.37797581,0.201725474 3.25498238,0.414756359 3.25498239,0.64529975 L3.25498239,8.48315985 L1.29298355,6.52048362 C1.13003545,6.35710248 0.892249438,6.29316238 0.669335827,6.35278623 C0.446422215,6.41241008 0.272309432,6.58652287 0.212685581,6.80943648 C0.153061731,7.03235009 0.217001824,7.2701361 0.38038297,7.4330842 L3.44398182,10.4975839 Z"
                id="Path"
              ></path>
            </g>
          </g>
        </g>
      </SvgIcon>
    );
  }),
);
